module.exports = __webpack_public_path__ + "img/ga.8629ddf5.svg";